import { createGlobalStyle } from 'styled-components'

export const COLORS = {
  Background: 'black',
  Nav: '#1a1a1a',
  Text: 'white',
  Link: '#abf3ee',
  HoverBG: '#666666',
  HoverFG: 'white',
  PostBG: '#1a1a1a'
};

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: black;
    padding: 0;
    margin: 0;
    a {
      color: ${COLORS.Link};
    }
  }
`
